import { sanityImageToBasicImage } from "@lib/utils/sanityImageToBasicImage";
import { css, styled } from "@sourceful/shared-components";
import { ProductMain } from "@sourceful/shared-types";
import toRem from "@styles/postprocess/conversion/to-rem";
import { ProductDetailContent } from "../../../components/productDetails/ProductDetailContent";
import ProductDetails from "./ProductDetails";
import ProductImageGallery from "./ProductImageGallery";

export const galleryStyles = css({
  margin: "0 auto",
});

export const ProductOverviewWrapper = styled("div", {
  background: "#ffffff",
  padding: toRem(10),
  width: "100%",
  height: "fit-content",
  paddingLeft: toRem(15),
  paddingRight: toRem(15),
  "@lg": {
    padding: toRem(10),
  },
});

export const StyledProductDetailContent = styled(ProductDetailContent, {
  "@lg": {
    gridTemplateColumns: `1fr ${toRem(360)}`,
  },
});

interface ProductOverviewProps {
  displayConfigureButton: boolean;
  product: ProductMain;
}

const ProductOverview = ({ product, displayConfigureButton }: ProductOverviewProps) => {
  return (
    <ProductOverviewWrapper>
      <StyledProductDetailContent>
        <ProductImageGallery
          images={product?.images?.map(sanityImageToBasicImage) ?? []}
          isSticky
          wrapperClassName={galleryStyles()}
        />
        <ProductDetails product={product} displayConfigureButton={displayConfigureButton} />
      </StyledProductDetailContent>
    </ProductOverviewWrapper>
  );
};

export default ProductOverview;
